import { SearchMaskGroupType, SearchMaskInputType, } from '../../globalTypes';
var UserPaginationCreator = /** @class */ (function () {
    function UserPaginationCreator() {
    }
    UserPaginationCreator.create = function (lturState, searchMaskGroupType, forceDefaultPagination, forceDefaultSorting) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        if (forceDefaultPagination === void 0) { forceDefaultPagination = false; }
        if (forceDefaultSorting === void 0) { forceDefaultSorting = false; }
        if (!lturState
            || !lturState.websiteState
            || !lturState.websiteState.searchMask.searchMaskBundle
            || !lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]) {
            return null;
        }
        var inputGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var pagination = { page: 0, size: 10 };
        if (inputGroup
            && inputGroup.inputs[SearchMaskInputType.PAGINATION] !== null
            && inputGroup.inputs[SearchMaskInputType.PAGINATION] !== void 0) {
            if (forceDefaultPagination) {
                pagination.page = inputGroup.inputs[SearchMaskInputType.PAGINATION].defaultValue.value.page;
                pagination.size = inputGroup.inputs[SearchMaskInputType.PAGINATION].defaultValue.value.size;
            }
            else {
                pagination.page = inputGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue.value.page;
                pagination.size = inputGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue.value.size;
            }
            if (forceDefaultSorting) {
                pagination.sorting = inputGroup.inputs[SearchMaskInputType.PAGINATION].defaultValue.value.sorting;
            }
            else {
                pagination.sorting = inputGroup.inputs[SearchMaskInputType.PAGINATION].confirmedValue.value.sorting;
            }
        }
        return pagination;
    };
    return UserPaginationCreator;
}());
export { UserPaginationCreator };
export default UserPaginationCreator;
